<template>
  <div class="page_container warehousingRecordPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >商务&销售管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>退款申请审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl"></div>
        <div class="filter flex-rowr">
          <div class="screen_wrap flex-rowr">
            <div
              class="txt"
              v-for="(item, index) in checkstateList"
              :key="index"
              :class="params.checkstate == item.value ? 'active' : ''"
              @click="handleState(item.value)"
            >
              {{ item.text }}
            </div>
          </div>
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入关键字查找→"
              @keyup.enter.native="handleSearch"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示退款申请列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div
                class="content_wrap flex-between"
                @click="handleDetail(item.id, item.openid)"
              >
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>退款工单号：<span>{{item.workno}}</span></p>
                    <p>
                      订单编号：<span>{{ item.orderno }}</span>
                    </p>
                    <p>
                      创建时间：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                    <p>
                      账户姓名：<span>{{ item.truename }}</span>
                    </p>
                    
                    <!-- <p>
                      账户id：<span>{{ item.accountid }}</span>
                    </p>
                    <p>
                      用户手机号：<span>{{ item.mobile }}</span>
                    </p> -->
                  </div>
                  <div class="block">
                    <p class="label">
                      物流类型：<span>{{ item.service_companystr }}</span>
                    </p>
                    <p class="label">
                      发货物流单号：<span>{{ item.service_no }}</span>
                    </p>
                    <p class="label">
                      退款类型：<span>{{ item.logtypestr }}</span>
                    </p>
                    <p class="label">
                      退款金额：<span>{{ item.fee }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p class="label">
                      退款情况：<span>{{ item.returnnotestr }}</span>
                    </p>
                     <p class="label">
                      退款属性：<span>{{ item.returnattrstr }}</span>
                    </p>
                    <p class="label">
                      退费原因：<span>{{ item.reasonidstr }}</span>
                    </p>
                    <p class="label">
                      退款状态：<span>{{ item.returnstate }}</span>
                    </p>
                    <p class="label">
                      退款审核状态：<span>{{
                        item.checkstatestr}}</span>
                    </p>
                  </div>
                  <div class="block">
                    <!-- <p class="label">
                      是否取消退款：<span>{{
                        item.iscancel == 1 ? "是" : "否"
                      }}</span>
                    </p> -->
                   
                    <p class="label">
                      退款时间：<span>{{ item.returndate | formatDate }}</span>
                    </p>
                    <p class="label">
                      备注：<span>{{ item.talk }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="detail_icon" @click="handleDetail(item.id)">
                  <i class="iconfont icon-details"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import {encryptstringadd} from '../../../api/api'
import { getBacklogList } from "../../../api/shop";
// import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cBacklogList",
  data() {
    return {
      loading: false,
      qyid: "",
      dataList: [],
      type: "",
      checkstateList: [
        { value: 1, text: "审核中" },
        { value: 2, text: "审核中（待退货）" },
        { value: 3, text: "审核中（已收到退货）" },
        { value: 4, text: "同意退款" },
        { value: 5, text: "用户取消退款" },
        { value: 6, text: "客服协商取消退款" },
      ],
      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        checkstate: 1,
        qyguid: ''
      },
      listTotal: 0,
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.type = this.$route.params.type;
    let { USERINFO } = this.$store.state;
    if (USERINFO.qy) {
      this.params.qyguid = USERINFO.qy.qyguid;
    } else {
      this.params.qyguid = 0;
    }
    // this.params.openid = this.$store.state.OPENID;
    this.getBacklogList();
  },
  methods: {
    // 搜索
    handleSearch() {
      this.params.pageindex = 1;
      this.getBacklogList();
    },
    // 状态
    handleState(type) {
      this.params.pageindex = 1;
      this.params.checkstate = type;
      this.getBacklogList();
    },

    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.getBacklogList();
    },
    // 重置数据
    handleRest() {
      this.params.keyword = ''
      this.params.pageindex = 1
      this.params.checkstate = 1
      this.getBacklogList()
    },
    getBacklogList() {
      this.loading = true;
      getBacklogList(this.params).then((res) => {
        this.dataList = res.list;
        this.listTotal = res.total;
        this.loading = false;
      });
    },
    handleDetail(id) {
      this.encryptstringadd("cBacklogDetail", { id});
      // this.$router.push(`/comSalesIndex/cBacklogDetail/${id}`);
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .list_wrap {
    height: 56vh;
  }
  .main_container {
    .screen_wrap {
      font-size: 14px;
      margin-right: 30px;
      .txt {
        cursor: pointer;
        &.active {
          font-size: 16px;
          color: red;
        }
        &:nth-child(2n) {
          margin: 0 20px;
        }
      }
    }
    .select_add {
      p {
        &:last-child {
          margin-left: 49px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .red {
      color: #ee0032;
    }
  }
  .intro_box {
    cursor: pointer;
    .shop_item {
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
}
</style>